import React, { useContext, useEffect, useState, useLayoutEffect } from 'react';
import { Passaggio } from '../App';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import './Carrello.css'; // CSS indipendente

const Carrello = () => {
  const Contesto = useContext(Passaggio);
  const { url } = useContext(Passaggio);
  const [carrello, setcarrello] = useState([]);
  const [satispay, setSatispay] = useState('');
  const link = useNavigate();


  useEffect(() => {
    creaEl();
  }, [Contesto.ordine]);

  useLayoutEffect(() => {
    controllaToken();
    creaEl();
  }, []);

  const controllaToken = () => {
    fetch(url + "/contolloToken", {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': "Bearer " + sessionStorage.getItem("token")
      }
    })
      .then(response => response.json())
      .then((dati) => {
        if (dati.risultato === "ko" || dati.risultato === undefined) {
          Swal.fire({ title: 'Login fallito. Riprova.', icon: 'warning', timer: 1500, showConfirmButton: false });
          link("/");
        }
      });
  }

  const creaEl = () => {
    let elem = [];
    Contesto.ordine.forEach((el, i) => {
      elem.push(
        <div key={i} className='pulsante'>
          <div className='formattatesto'>{el.prodotto}</div>
          <div className='formattainfo'>PREZZO: {el.prezzo}€</div>
          <div className='formattainfo'>QTA: {el.qta}</div>
          <div onClick={() => elimina(el, i)}>
            <div className='elimina'><div className='sposta'>-</div></div>
          </div>
        </div>
      );
    });
    setcarrello(elem);
  }

  const elimina = (el, i) => {
    Contesto.setqta(qta => qta - 1);
    Contesto.setordine(Contesto.ordine.filter((item, ind) => {
      if (ind !== i) return item;
      else {
        Contesto.settotale(totale => totale - item.prezzo);
        if (item.qta > 1) {
          item.qta--;
          return item;
        }
      }
    }));
  }

  const messaggio = () => {
    Swal.fire({ title: 'Max 15€ per ordine', icon: 'warning', timer: 1500, showConfirmButton: false });
  }

  const creaOrdine = () => {

    Contesto.setidOrdine(Contesto.idOrdine + 1);
    const ord = {
      ordineID: Contesto.idOrdine,
      user: sessionStorage.getItem('token'),
      email: sessionStorage.getItem('token'),
      cittaID: sessionStorage.getItem('idCitta'),
      localeID: sessionStorage.getItem('idLocale'),
      importoTotale: Contesto.totale,
      satispay:satispay,
      prodotti: Contesto.ordine.map(item => ({
        prodottoID: item.idProd,
        prodottoDesc: item.prodotto,
        prezzoUnitario: item.prezzo,
        quantita: item.qta,
      }))
    };
    effettuaOrdinazione(ord);
    Contesto.settotale(0);
    Contesto.setordine([]);
    Contesto.setqta(0);
  }

  const effettuaOrdinazione = (ordinazione) => {
    const link = url + '/ordinazione';
    fetch(link, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': "Bearer " + sessionStorage.getItem("token")
      },
      body: JSON.stringify({ ordine: [ordinazione] })
    })
      .then(response => response.json())
      .then(data => {
        if (data.ordine.includes('OK')) {
          Swal.fire({ title: 'Il tuo ordine è stato inviato!', timer: 1500, showConfirmButton: false, icon: 'success', width: "65vw" });
        } else {
          Swal.fire({ title: 'Ordine non inviato!', timer: 1500, showConfirmButton: false, icon: 'warning', width: "65vw" });
        }
      });
  }

  return (
    <div className="carrelloPage">
      <div className="contenitoreCarrello">

        <div className="headerCarrello">
          <div className="avviso">ORDINE MAX 15 EURO</div>
          <div className="tot">TOTALE: {Contesto.totale}€</div>
        </div>
        <div className="selezioneIntestatario">
          <label>Satispay:</label>
          <input
            type="text"
            value={satispay}
            onChange={(e) => setSatispay(e.target.value)}
            placeholder="Intestatario..."
            className="inputSatispay"
          />
        </div>
        <div className="listaProdotti">
          {Contesto.ordine.length === 0 ? <div className="vuoto">CARRELLO VUOTO</div> : carrello}
        </div>

        <div className="footerCarrello">
          <div
            className={"ordina"}
            onClick={() => {
              if (Contesto.ordine.length === 0) {
                Swal.fire({
                  title: 'Carrello vuoto!',
                  icon: 'warning',
                  timer: 1500,
                  showConfirmButton: false
                });
              }
              else if (satispay.trim() === "") {
                Swal.fire({
                  title: 'Intestatario Satispay!',
                  icon: 'warning',
                  timer: 1500,
                  showConfirmButton: false
                });
              }
              else if (Contesto.totale > 15) {
                Swal.fire({
                  title: 'Max 15€ per ordine',
                  icon: 'warning',
                  timer: 1500,
                  showConfirmButton: false
                });
              }
              else {
                creaOrdine();
              }
            }}
          >
            ORDINA
          </div>
        </div>

      </div>
    </div>
  );
}

export default Carrello;